import React from 'react';
import { pageText } from '../../content/publicPages';
import { usePublicPage } from '../../hooks/usePublicPage';

/**
 * Shopify night shelf — rounded overlap under the hero.
 * One headline, one support line.
 */
const MarketingLayerBand = () => {
  const { saved, defaults } = usePublicPage('home');
  return (
    <section className="marketing-layer px-4 pb-14 pt-8 sm:px-6 sm:pb-20 sm:pt-10">
      <div className="mx-auto w-full max-w-5xl">
        <h2 className="marketing-section-title mb-3 text-m-on-dark">
          {pageText(saved.layer_title, defaults.layer_title)}
        </h2>
        <p className="marketing-body-lg max-w-3xl text-white/85">
          {pageText(saved.layer_body, defaults.layer_body)}
        </p>
      </div>
    </section>
  );
};

export default MarketingLayerBand;
